module.exports = __webpack_public_path__ + "media/images/SH_header-8e76e9f2f53c5158711100a8f536928b.jpg";